<template>
  <div justify="center">
    <v-dialog
      scrollable
      v-model="show"
      max-width="300px"
      @click:outside="init()"
      @keydown="$event.key === 'Escape' ? init() : ''"
    >
      <v-card>
        <v-card-text class="pt-6 msg" v-html="msg">
        </v-card-text>
        <v-card-actions class="pb-6 pr-6 pt-2">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            @click="init()"
          >
            {{ noneCallback === false ? '취소' : '확인' }}
          </v-btn>
          <v-btn
            :color="color"
            v-if="noneCallback === false"
            depressed
            @click="func"
          >
            {{ btnText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'DlgConfirm',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    btnText: {
      type: String,
      default: '확인',
    },
    color: {
      type: String,
      default: 'primary',
    },
    msg: {
      type: String,
    },
    func: {
      type: Function,
      default: () => {},
    },
    noneCallback: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
    }),
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    init() {
      this.$emit('update:show', false);
    },
  },
};
</script>

<style scoped lang="scss">
.msg{
  font-size: 1rem;
  color: #333 !important;
  font-weight: 500;
}
</style>
